import InputField from './InputField';

export default InputField;



// WEBPACK FOOTER //
// ./src/components/form/InputField/index.jsx